import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useProductRoomFormModelContext } from "../context";
import { QuestionRoomAddressRoot } from "./address/root";
import { QuestionRoomAdvancedPricing } from "./advanced-pricing/root";
import { QuestionRoomBase } from "./base/root";
import { QuestionRoomConnection } from "./connection/root";
import { QuestionRoomDiscountSetting } from "./discount-setting/root";
import { QuestionRoomDormitory } from "./dormitory/root";
import { QuestionRoomPriceAndStockAndPolicy } from "./price-and-stock-and-policy/root";
import { QuestionRoomDetailInfo } from "./room-detail-info/root";
import { QuestionRoomSalesTerm } from "./sales-term/root";

import type { StandardRoomCategoriesAndManagerStore } from "../store/categories";

type Props = {
	langCode?: LangCode;

	roomCategoriesAndManagerStore: Omit<
		StandardRoomCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
};

export const RoomFormMain = ({ roomCategoriesAndManagerStore }: Props) => {
	const { hotelID, roomID } = useProductRoomFormModelContext().viewModel;

	const {
		base, //
		connection,
		discountSetting,
		address,
		advancedPricing,
		roomDetailInfo,
		dormitory,
		salesTerm,
		priceAndStockAndPolicy,
	} = roomCategoriesAndManagerStore;

	return (
		<>
			<QuestionRoomBase hotelID={hotelID} roomID={roomID} base={base} />
			<QuestionRoomPriceAndStockAndPolicy priceAndStockAndPolicy={priceAndStockAndPolicy} />
			<QuestionRoomConnection connection={connection} />
			<QuestionRoomDiscountSetting discountSetting={discountSetting} />
			<QuestionRoomSalesTerm salesTerm={salesTerm} />
			<QuestionRoomDetailInfo roomDetailInfo={roomDetailInfo} />
			<QuestionRoomAddressRoot address={address} />
			<QuestionRoomDormitory dormitory={dormitory} />
			<QuestionRoomAdvancedPricing advancedPricing={advancedPricing} />
		</>
	);
};

RoomFormMain.displayName = "RoomFormMain";
